import { ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';
import { Widget } from 'src/app/classes';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE, WIDGET_STANDALONE_COMPONENT_SERVICE } from 'src/app/interfaces';
import { AbstractWidgetInner } from 'src/app/widget-inner';
import { WidgetViewStandaloneComponentService } from '../../widget-view-standalone/widget-view-standalone-component-service';

@Component({
  selector: 'app-unknown-type',
  templateUrl: './unknown-type.component.html',
  styleUrls: ['./unknown-type.component.css']
})
export class UnknownTypeComponent extends AbstractWidgetInner {

  @ViewChild("body", { static: true }) body: ElementRef;
  expandedView: boolean = false;

  constructor(
    @Inject(WIDGET_STANDALONE_COMPONENT_SERVICE) private _widgetViewStandaloneComponentService: WidgetViewStandaloneComponentService,
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _ref: ChangeDetectorRef
  ) {
    super();
  }

  changeWidgetType = () => this._widgetProviderService.widget$.pipe(take(1)).subscribe((widget: Widget) => this._widgetViewStandaloneComponentService.changeWidgetType(widget));

  deleteWidget = () => this._widgetProviderService.widget$.pipe(take(1), switchMap((widget: Widget) => this._widgetViewStandaloneComponentService.deleteWidget(widget))).subscribe(() => location.reload());

  ngAfterViewInit(): void {
    if ((this.body.nativeElement as HTMLDivElement).clientWidth > 200 && (this.body.nativeElement as HTMLDivElement).clientHeight > 200) {
      this.expandedView = true;
    } else this.expandedView = false;
    this._ref.detectChanges();
  }

}
